import { makeStyles } from '@material-ui/core';
import { COLORS } from 'constants/index';

const useGlobalStyles = makeStyles({
  buttonContainer: {
    paddingTop: '16px',
  },
  actionButtonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  divider: {
    marginLeft: '-24px',
    marginRight: '-24px',
  },
  gridNoSpacing: {
    margin: 0,
    width: '100%',
  },
  link: {
    color: COLORS.BLUE,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  thumbnail: {
    width: '40px',
    height: '40px',
    borderRadius: '2px',
  },
});

export default useGlobalStyles;
